import React from 'react'
import Payslip from '../components/payslip'
import PageviewGA from '../components/pageview-ga'

export default class extends React.Component {

    render() {
        return(
            <div className="layout-row flex">
                <PageviewGA/>
                <Payslip {...this.props} payslip={this.props.store.latest_payslip} title="Latest Payslip"/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/latest_payslip.js